import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useMemo } from 'react';
import { useUserSession } from '../../../../../../../models/hooks/appStateHooks';
import { TagsListWithTagsEditor } from '../../../../../../components/entities/tags/TagsEditor';
import { TagIcon } from '../../../../../../components/svgs/icons/TagIcon';
import { navigation } from '../../../../../../styles/colors';
import { bs } from '../../../../../../styles/styles';
import { useContactTagsUtils } from './hooks/useContactTagsUtils';

type Props = {
	contact: Api.IContact;
	refetchContact: () => void;
};

export function Tags({ contact, refetchContact }: Props) {
	const { tags, onRequestAddTag, onRequestRemoveTag, isLoading } = useContactTagsUtils(contact, refetchContact);
	const userSession = useUserSession();

	const contactViewModel = useMemo(() => {
		return new Api.ContactViewModel(userSession, contact);
	}, [userSession, contact]);

	return (
		<div className={css(bs.mt5, bs.wFull)}>
			<div className={css(bs.flex, bs.justifyStart)}>
				<TagIcon className={css(bs.flexShrink0, bs.mr4, bs.mt3, bs.w4)} fillColor={navigation} />
				<TagsListWithTagsEditor
					tagType={Api.ResourceAutoCompleteViewModelType.AccountTag}
					className={css(bs.flex1)}
					disabled={isLoading}
					entity={contactViewModel}
					onRequestAddTag={onRequestAddTag}
					onRequestRemoveTag={onRequestRemoveTag}
					tags={tags}
				/>
			</div>
		</div>
	);
}
